export default {
  SEMIFINISHEDS: (state) => state.semifinisheds,
};
